<template>
  <el-row justify="center" class="auth-container">
    <el-col :xs="24" :sm="12" :md="8" :lg="6">

      <el-card class="auth-card" shadow="hover">
        <template #header>
          <div class="card-header">
            <h5 class="mb-0 text-center">忘记密码</h5>
          </div>
        </template>

        <el-alert
          v-if="message"
          :title="message"
          type="success"
          show-icon
          :closable="false"
          class="mb-3"
        >
          <router-link :to="{ name: 'ResetPasswordConfirm', query: { email: this.email } }" class="el-link el-link--primary mt-2 d-block">
            我已经收到令牌了，带我去重置页面
          </router-link>
        </el-alert>

        <el-alert
          v-if="error"
          :title="error"
          type="error"
          show-icon
          :closable="false"
          class="mb-3"
        />

        <el-form @submit.prevent="handleResetRequest" v-if="!message" label-position="top">
          <p class="text-muted">请输入您注册时使用的电子邮箱。我们将向该邮箱发送一个重置令牌。</p>

          <el-form-item label="电子邮箱" prop="email">
            <el-input
              v-model="email"
              type="email"
              size="large"
              placeholder="请输入电子邮箱"
              required
            />
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              class="w-100"
              size="large"
              @click="handleResetRequest"
              :loading="isLoading">
              {{ isLoading ? '正在发送...' : '发送重置令牌' }}
            </el-button>
          </el-form-item>
        </el-form>

        <div class="text-center mt-3">
          <router-link to="/login" class="el-link el-link--info">
            返回登录
          </router-link>
        </div>
      </el-card>

    </el-col>
  </el-row>
</template>

<script>
//
// <script> 部分完全保持不变
//
import axios from 'axios';

export default {
  name: 'ForgotPasswordView',
  data() {
    return {
      email: '',
      isLoading: false,
      message: null,
      error: null,
    };
  },
  methods: {
    async handleResetRequest() {
      this.isLoading = true;
      this.message = null;
      this.error = null;

      try {
        await axios.post('/api/password_reset/', {
          email: this.email
        });

        // (API 总是返回 200 OK, 即使邮箱不存在)
        this.message = `如果 ${this.email} 在我们的系统中存在，一封包含重置令牌的邮件已发送至该地址。`;

      } catch (err) {
        console.error('密码重置请求失败:', err);
        this.error = '操作失败。请确保邮箱格式正确或稍后再试。';
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<style scoped>
/* --- V4.0 样式 --- */
.auth-container {
  padding-top: 5rem;
}
.auth-card {
  border-radius: 8px;
}
.card-header h5 {
  font-weight: 600;
  color: var(--el-text-color-primary);
}
.w-100 {
  width: 100%;
}
.mb-0 { margin-bottom: 0; }
.mb-3 { margin-bottom: 1.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 1rem; }
.text-center { text-align: center; }
.text-muted {
  font-size: 0.9rem;
  color: var(--el-text-color-secondary);
}
.d-block {
  display: block;
}
</style>